import { Button, Input, Pagination } from '@nextui-org/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';


const AllTds = () => {


    const [tds, setTds] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [uiChange, setUiChange] = useState(false);
    const [isDateRange, setIsDateRange] = useState(false);


    const deleteTds = async (id) => {
        const result = window.confirm("Sure? Want to delete ?");

        if (!result) {
            return
        }

        try {
            const response = await axios.delete(`/tds-gst/tds/${id}`);
            if (response.data.success) {
                toast.success(response.data.message);
                setUiChange(!uiChange);
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    const downloadSheet = async () => {
        if (tds.length === 0) {
            toast.error("No data found to export");
            return;
        }
        const arr = [];
        let tdsRecords = tds;
        if (!isDateRange) {
            try {
                const response = await axios.get(`/tds-gst/tds-export`);
                if (response.data.success) {
                    tdsRecords = response.data.tds;
                }
            } catch (error) {
                toast.error(error.response.data.message);
            }
        }
        let total = 0;
        tdsRecords.forEach(td => {
            let date = td.date;
            date = new Date(date).toLocaleDateString('en-GB');
            const sheet = {
                ...td,
                date
            }
            delete (sheet._id);
            delete (sheet.__v);
            delete (sheet.createdAt);
            delete (sheet.updatedAt);
            arr.push(sheet);
            total += sheet.amount;
        });

        const obj = {
            date: "Total Amount",
            amount: total
        }

        arr.push(obj);


        const workSheet = XLSX.utils.json_to_sheet(arr);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'Sheet1');
        XLSX.writeFile(workBook, 'tds.xlsx');
    }

    const getAllTds = async () => {

        try {
            const response = await axios.get(`/tds-gst/all-tds?page=${currentPage}&limit=50`);
            if (response.data.success) {
                setTds(response.data.tds);
                setTotalPages(response.data.totalPages);
                setIsDateRange(false);
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    useEffect(() => {

        getAllTds();
    }, [uiChange, currentPage])

    const getTdsByDateRange = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        const startDate = new Date(data.startDate);
        const endDate = new Date(data.endDate);

        try {
            const response = await axios.get(`/tds-gst/search/tds/by-date-range?startDate=${startDate}&endDate=${endDate}`);
            if (response.data.success) {
                setTds(response.data.tds);
                setIsDateRange(true);
                setTotalPages(0);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            setTds([]);
        }
    }


    return (
        <>
            <h1 className='text-center mt-2 underline'>TDS</h1>

            <form onSubmit={getTdsByDateRange} className="absolute top-20 left-8 flex items-center gap-2">
                <Input label={"start date"} type="date" className="max-w-sm" name="startDate" />
                <Input label={"end date"} type="date" className="max-w-sm" name="endDate" />
                <Button color="warning" type="submit" className="w-[200px] text-white">Get Tds</Button>
            </form>

            <div className='flex justify-end'>
                <Button onClick={downloadSheet} color="warning" className="m-6 text-white ">Download</Button>
            </div>

            <div className="ml-9">
                <i onClick={getAllTds} className="fa-solid fa-rotate-right font-bold cursor-pointer" title="refresh"></i>
            </div>

            <div className="border rounded-lg overflow-hidden mt-5 shadow mx-6">
                <table className="min-w-full divide-y divide-gray-200 ">
                    <thead className="bg-gray-50 ">
                        <tr>
                            <th
                                scope="col"
                                className="font-bold px-6 py-3 text-start text-s text-gray-500 uppercase"
                            >
                                Date
                            </th>
                            <th
                                scope="col"
                                className="font-bold px-6 py-3 text-start text-s text-gray-500 uppercase"
                            >
                                Amount
                            </th>
                            <th
                                scope="col"
                                className="font-bold px-6 py-3 text-start text-s text-gray-500 uppercase"
                            >
                                Mode of Payment
                            </th>
                            <th
                                scope="col"
                                className="font-bold px-6 py-3 text-start text-s text-gray-500 uppercase"
                            >
                                Reason
                            </th>

                            <th
                                scope="col"
                                className="font-bold px-6 py-3 text-start text-s text-gray-500 uppercase"
                            >
                                Credited
                            </th>
                            <th
                                scope="col"
                                className="font-bold px-6 py-3 text-start text-s text-gray-500 uppercase"
                            >
                                Debited
                            </th>
                            <th
                                scope="col"
                                className="font-bold px-6 py-3 text-start text-s text-gray-500 uppercase"
                            >
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {tds?.map((e, index) => {
                            return (
                                <>
                                    <tr>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                            {new Date(e?.date).toLocaleDateString("en-GB")}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                            {e?.amount}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                            {e?.modeOfPayment}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                            {e?.reason}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                            {e?.credited}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                            {e?.debited}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">

                                            <i onClick={() => deleteTds(e?._id)} class="fa-solid fa-trash text-red-600 hover:cursor-pointer hover:scale-150"></i>

                                        </td>

                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {
                totalPages > 1 && (
                    <div className="flex justify-center mt-5">
                        <Pagination
                            showControls
                            initialPage={currentPage}
                            total={totalPages}
                            onChange={(page) => setCurrentPage(page)} />
                    </div>
                )
            }
        </>
    )
}

export default AllTds;